'use client';

import { RefObject, useRef } from 'react';
import { Box, Button, HStack, Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import YandexMap from '../components/YandexMap';
import AddressDetails, {
  AddressDetailsRef,
} from '../components/AddressDetails';
import AddressSearch from '../components/YandexMap/components/AddressSearch';
import type { DeliveryZoneValue } from '@/_hooks/useDeliveryZone';

const Desktop = ({
  city,
  mapRef,
  onChange,
  geometry,
  isLoading,
  errorZone,
  addressName,
  deliveryZone,
  setDeliveryZone,
  markerCoords,
  accommodation,
  handleClear,
  onMapBounded,
  onAddressSelect,
}: {
  mapRef: RefObject<null>;
  geometry: [number, number];
  city: string;
  errorZone: boolean;
  isLoading: boolean;
  addressName: string;
  handleClear: () => void;
  deliveryZone: DeliveryZoneValue;
  setDeliveryZone: (zone: DeliveryZoneValue) => void;
  markerCoords: number[];
  accommodation: string;
  onAddressSelect: (e: any) => void;
  onMapBounded: (e: number[]) => void;
  onChange: (
    value: { address: string; city: string; house: string; location: number[] },
    isSelect: boolean
  ) => void;
}) => {
  const t = useTranslations();
  const addressDetailsRef = useRef<AddressDetailsRef>(null);

  const handleSaveAddress = () => {
    addressDetailsRef.current?.saveAddress();
  };

  return (
    <Stack gap={6} w={'full'} p={6} h={'full'}>
      <Box color={'text'}>
        <Text fontWeight={700} fontSize={24}>
          {t('select_delivery_address')}
        </Text>
        <Text fontSize={'sm'} mt={1} color={'text.muted'}>
          {t('this_allows_you_see_the_current_menu')}
        </Text>
        <HStack gap={2} mt={5}>
          <Box top='100%' left='0px' zIndex={1} w='100%'>
            <AddressSearch
              isIcon
              variant='subtle'
              region={geometry}
              value={addressName}
              onSelect={onAddressSelect}
            />
          </Box>
        </HStack>
        <AddressDetails
          ref={addressDetailsRef}
          city={city}
          isDesktop={true}
          deliveryZone={deliveryZone}
          setDeliveryZone={setDeliveryZone}
          errorZone={errorZone}
          isLoading={isLoading}
          coords={markerCoords}
          address={addressName}
          onClear={handleClear}
          accommodation={accommodation}
        />
      </Box>
      <Box
        flex={1}
        h='100%'
        rounded={16}
        display='flex'
        overflow='hidden'
        position='relative'
      >
        <YandexMap
          mapRef={mapRef}
          isMobile={false}
          geometry={geometry}
          errorZone={errorZone}
          outerLoading={isLoading}
          onLocationChange={onChange}
          deliveryZone={deliveryZone}
          onMapBounded={onMapBounded}
        />
      </Box>
      <Button
        onClick={handleSaveAddress}
        w={'100%'}
        size='xl'
        rounded={16}
        h={'56px'}
        bg='primary'
        color='primary.text'
        _hover={{
          bg: 'primary.hover',
        }}
        disabled={errorZone || isLoading || !addressName}
      >
        {isLoading ? t('location.determining_location') : t('save')}
      </Button>
    </Stack>
  );
};

export default Desktop;
